import React from 'react'
import MultiComplete from 'components/Wizard2/fieldComponents/MultiComplete'
import { GET_WEB_SEARCH_COLUMNS } from 'requests'

const WebSearchColumnSelector = ({value, onChange, id}) => {
  const [webSearchColumns, setWebSearchColumns] = React.useState([])

  React.useEffect(() => {
    GET_WEB_SEARCH_COLUMNS(lists => {
      setWebSearchColumns(lists.map(list => ({
        value: list.NAME,
        label: list.DISPLAY_DESCR
      })))
    })
  }, [])

  return (
    <div> 
      <MultiComplete
        value={value}
        onChange={onChange}
        options={webSearchColumns}
        width="70%"
        disabled={!webSearchColumns.length}
      />
    </div>
  )
}

export default WebSearchColumnSelector